import { render, staticRenderFns } from "./BoxCell.vue?vue&type=template&id=295c372e&scoped=true&lang=html&"
import script from "./BoxCell.vue?vue&type=script&lang=js&"
export * from "./BoxCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c372e",
  null
  
)

export default component.exports